<div *ngIf="ribbonData?.text" class="ribbon" [ngClass]="ribbonClass">
  <span class="mat-caption">{{ ribbonData.text | translate }}</span>
</div>
